<agr-dialog [data]="data" (cancel)="cancel()">
  <div class="dialog-container">
    <!-- Main image area -->
    <div class="image-area">
      <div class="zoom-controls">
        <button mat-icon-button class="btn btn--zoom" (click)="onZoomIn()"><mat-icon>zoom_in</mat-icon></button>
        <button mat-icon-button class="btn btn--zoom" (click)="onZoomOut()"><mat-icon>zoom_out</mat-icon></button>
      </div>

      <div
        #imageWrapper
        class="image-wrapper"
        (pointerdown)="onPointerDown($event)"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp($event)"
      >
        @if (isLoadingMore()) {
          <div class="loading-more-overlay">
            <mat-spinner diameter="40"></mat-spinner>
            <p>{{ 'TGA.Advice.Cultivation.SatelliteImages.Dialog.LoadingMore' | translate }}</p>
          </div>
        } @else if (hasImageForDisplayedDate()) {
          <img [src]="imageForDisplayedDate() | dataUri" alt="Satellite" [style.transform]="imageTransform()" />
        } @else {
          <div class="no-image-placeholder">
            <p class="no-image-title">{{ 'TGA.Advice.Cultivation.SatelliteImages.Dialog.NoImage' | translate }}</p>
            <p class="no-image-date">{{ displayedDate() | date: 'd MMMM yyyy' : undefined : locale() }}</p>
          </div>
        }
      </div>

      <!-- Legend -->
    </div>

    <!-- Legend above thumbnails -->
    <div class="legend-section">
      <span class="legend-title">{{ 'TGA.Advice.Cultivation.SatelliteImages.Legend.Title' | translate }}</span>
      <div class="legend-row">
        <span class="legend-label">{{ 'TGA.Advice.Cultivation.SatelliteImages.Legend.Low' | translate }}</span>
        <div class="legend-gradient" [ngStyle]="gradientStyle()"></div>
        <span class="legend-label">{{ 'TGA.Advice.Cultivation.SatelliteImages.Legend.High' | translate }}</span>
      </div>
    </div>

    <!-- Thumbnail strip -->
    <div class="thumbnail-strip">
      <button
        mat-icon-button
        class="strip-nav-btn"
        [disabled]="!canGoToPrevious() && !canFetchMore()"
        (click)="onStripPrevious()"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>

      <div #thumbnailContainer class="thumbnail-scroll-container">
        @for (image of images(); track image.imageDate; let i = $index) {
          <button
            class="thumbnail-item"
            [class.active]="i === currentIndex() && !selectedDate()"
            (click)="onThumbnailClicked(i)"
          >
            <img [src]="image | dataUri" alt="Thumbnail" class="thumbnail-image" />
            <span class="thumbnail-date">{{ image.imageDate | date: 'd MMM' : undefined : locale() }}</span>
          </button>
        }
        @if (isLoadingMore()) {
          <div class="thumbnail-loading">
            <mat-spinner diameter="40"></mat-spinner>
          </div>
        }
      </div>

      <button mat-icon-button class="strip-nav-btn" [disabled]="!canGoToNext()" (click)="onStripNext()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>
</agr-dialog>
